export default {
  en: {
    'components.error.title': 'This is embarrassing! Something went wrong',
    'components.error.try-again': 'Try Again',
  },
};
